import React from 'react';

const gradients = {
  /** Same as header wordmark */
  default: 'from-blue-600 to-teal-600',
  /** Footer / dark backgrounds */
  footer: 'from-blue-400 to-teal-400',
  /** Light text on photo overlays (school quote strip) */
  onDark: 'from-teal-200 to-cyan-200',
};

/**
 * Brand wordmark gradient (matches nav). Use `variant` on dark sections.
 * @param {{ className?: string, variant?: 'default' | 'footer' | 'onDark' }} props
 */
export function BrandName({ className = '', variant = 'default' }) {
  const grad = gradients[variant] ?? gradients.default;
  return (
    <span
      className={`font-bold bg-gradient-to-r ${grad} bg-clip-text text-transparent ${className}`.trim()}
    >
      ChooseRightCareer
    </span>
  );
}
